 <template>
  <div class="container">
    <div class="row mt-5 mb-5">
      
      <div class="col-md-4">
        <div class="jumbotron">
            <h1 class="text-center texto">{{$t("p_join_boy_title")}}</h1>
            <p class="text-center">{{$t("p_join_boy_des")}}</p>
            <div class="text-center">
              <a class="btn btn-outline-warning buttora text-center" href="mailto:kibigo@kinoa.tech?Subject=Sono%20un%20ragazzo">{{$t("p_join_btn")}}</a>
            </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="jumbotron">
          <h1 class="text-center texto">{{$t("p_join_team_title")}}</h1>
          <p class="text-center">{{$t("p_join_team_des")}}</p>
          <div class="text-center">
              <a class="btn btn-outline-warning buttora text-center" href="mailto:kibigo@kinoa.tech?Subject=Siamo%20un%20team">{{$t("p_join_btn")}}</a>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="jumbotron">
          <h1 class="text-center texto">{{$t("p_join_school_title")}}</h1>
          <p class="text-center">{{$t("p_join_school_des")}}</p>
          <div class="text-center">
            <a class="btn btn-outline-warning buttora text-center" href="mailto:kibigo@kinoa.tech?Subject=Sono%20una%20scuola">{{$t("p_join_btn")}}</a>
          </div>
        </div>
      </div>

          </div>

<div class="row mb-4">
  <div class="col  text-center">
    <h2>{{$t("p_join_where")}}</h2>
  </div>
  
</div>

<div class="row  mb-5">
  <div class="col-md-2 ">
    <address>
    <strong>KibiGO</strong><br>
    Via Giovanni Bovio, 4<br>
    Firenze, 50136 Italia<br>
    <abbr title="Phone"></abbr> +39 055 23 474 478
  </address>
    </div>
    <div class="col-md-10">
<mapbox
access-token="pk.eyJ1Ijoia2lub2EtZGV2ZWxvcGVycyIsImEiOiJjamU3ZGRka2owMHBwMndvMHByZnZlazA0In0.YlHLezTdKYJF0HcZ-QHN7w"
:map-options="{
  style: 'mapbox://styles/kinoa-developers/cjjj3fedl2kgt2so6eslspulr',
  center: [11.274588, 43.773077],
  zoom: 19,
  tilt: 4,
  pitch: 55
}"
:geolocate-control="{
  show: true,
  position: 'top-left'
}"
:scale-control="{
  show: true,
  position: 'top-left'
}"
:fullscreen-control="{
  show: true,
  position: 'top-left'
}">
</mapbox>
    </div>
       
      
</div>

      <div class="row" style=" width: 100%;">
      
      
 
      
      
      </div>
      
          


        </div>

</template>

<script>
import Mapbox from 'mapbox-gl-vue';



export default {
  name: "ContactUs",
  data() {
    return {};
  },
  components: { Mapbox }
};
</script>

<style scoped>

#map {
  width: 100%;
  height: 500px;
}


.texto {
  color: #f0932b;
}

.buttora {
    color: rgb(71, 71, 71);
    background-color: #f0932b;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue